import { CardHeader, CardSection, CardWrapper } from 'foundations-components/transitional/components/Card';
import styled from 'styled-components';
import ExpandableSourcesList from '../sources/ExpandableSourcesList';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const FullHeightWrapper = styled.div.withConfig({
  displayName: "CardWithSources__FullHeightWrapper"
})(["height:100%;display:flex;flex-direction:column;"]);
export const CardWithSources = ({
  maxInlineSize,
  title,
  children,
  sourcesSections
}) => {
  return /*#__PURE__*/_jsx(FullHeightWrapper, {
    children: /*#__PURE__*/_jsxs(CardWrapper, {
      compact: true,
      maxInlineSize: maxInlineSize,
      children: [title && /*#__PURE__*/_jsx(CardHeader, {
        title: title,
        paddingBlockStart: "600 !important"
      }), children && /*#__PURE__*/_jsx(CardSection, {
        paddingBlockEnd: "400",
        children: children
      }), sourcesSections.length > 0 && /*#__PURE__*/_jsx(CardSection, {
        paddingBlockStart: "0",
        children: /*#__PURE__*/_jsx(ExpandableSourcesList, {
          sourcesSections: sourcesSections
        })
      })]
    })
  });
};